import React, { useEffect } from "react"; // <--- Tambahkan useEffect di sini
import { useNavigate } from "react-router-dom";

// ... (Import navbar/footer tetap sama)
import Navbar from "../../components/Index/Navbar";
import Footer from "../../components/Index/Footer";
import HomeSection from "../../components/Program Selection/home-section";
import HeroSection from "../../components/Program Selection/menu-aksi";

interface ComparisonData {
  title: string;
  features: string;
  path: string;
}

const comparisonData: ComparisonData[] = [
  {
    title: "Private Class (1-on-1)",
    features: "/Programs/private-class.jpeg",
    path: "/course/Private",
  },
  {
    title: "Semi Private Class",
    features: "/Programs/semi-class.jpeg",
    path: "/course/semiPrivate",
  },
];

// --- Comparison Card (Sudut Melengkung) ---
const ComparisonCard: React.FC<ComparisonData> = ({
  title,
  features,
  path,
}) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    // 1. Ambil data user dari localStorage
    const userStr = localStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : null;

    // 2. Cek apakah user ada
    if (!user) {
      // Jika belum login -> Alert & Redirect ke Login
      alert("Please login to view program details.");
      navigate("/auth/login");
    } else {
      // Jika sudah login -> Lanjut ke halaman program
      navigate(path);
    }
  };
  return (
    // PARENT: Background MERAH dengan rounded besar
    <div className="flex flex-col rounded-[50px] overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] bg-[#DF0000] h-full">
      {/* HEADER: Background transparan (karena parent sudah merah), teks putih */}
      <div className="py-8 px-4 text-center shrink-0">
        <h3 className="text-white text-3xl font-bold tracking-wide">{title}</h3>
      </div>

      {/* BODY: Background PUTIH dengan rounded TOP (agar melengkung di pertemuan merah-putih) */}
      <div className="bg-white rounded-t-[50px] p-8 flex-1 flex flex-col">
        <ul className="space-y-4 mb-8">
          {/* {comparisonData.map((feature, idx) => ( */}
          <li className="flex items-start gap-3">
            <span className="text-gray-800 text-[15px] font-medium leading-snug">
              <img
                src={features}
                alt={`Feature ${features}`}
                className="w-full h-auto rounded-lg"
              />
            </span>
          </li>
        </ul>

        {/* Button */}
        <div className="mt-auto">
          <button
            onClick={handleViewDetails}
            className="w-full bg-[#FF0000] hover:bg-[#D50000] text-white font-bold py-3.5 rounded-full text-lg shadow-md transition-colors active:scale-95"
          >
            Start Learning!
          </button>
        </div>
      </div>
    </div>
  );
};

// --- Main Program Selection Page ---
const ProgramSection: React.FC = () => {
  const navigate = useNavigate();

  // --- [BARU] USE EFFECT UNTUK SCROLL KE ATAS SAAT HALAMAN DIBUKA ---
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Data Placeholder
  const placeholderDesc =
    "Explore our structured curriculum designed to help you master the Indonesian language effectively and efficiently with our proven methods.";

  const placeholderPoints = [
    "Interactive learning materials.",
    "Native speaking instructors.",
    "Comprehensive assessment.",
  ];

  const bookImage = "/buku2.png";

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <HomeSection />

      <main
        id="programs-list"
        className="bg-[#FBFBFB] -mt-8 relative z-10 pt-4 pb-20 px-6 sm:px-12 lg:px-24 font-sans flex-grow"
      >
        <div className="max-w-7xl mx-auto">
          {/* Breadcrumb & Heading */}
          <div className="mb-10">
            <nav className="flex items-center space-x-3 text-sm mb-3 font-semibold">
              <span
                onClick={() => navigate("/")}
                className="text-[#A70006] cursor-pointer hover:underline"
              >
                Home
              </span>
              <span className="text-gray-300">▸</span>
              <span className="text-black">Program</span>
            </nav>
            <h1 className="text-5xl font-bold text-black mb-4 tracking-tighter">
              Fluenesia Program
            </h1>
            <p className="text-gray-500 text-lg font-medium max-w-2xl">
              Explore our available programs and choose the one that fits you
              best.
            </p>
          </div>

          {/* --- COMPARISON SECTION --- */}
          <div className="mb-12">
            {/* Comparison Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              {comparisonData.map((data, index) => (
                <ComparisonCard key={index} {...data} />
              ))}
            </div>
          </div>
        </div>
      </main>

      <HeroSection />
      <Footer />
    </div>
  );
};

export default ProgramSection;
